import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as extract from '../../../extractFromState';
import { DecisionTreeButton } from '../../common/buttonsComponents';
import { restartDecisionFlowRequested, setMacroWizardPath, setNoMatchPage } from '../../../actions/searchActions';
import { trackMacroWizardCategorySelected } from '../../../analytics/searchEventAnalytics';
import { tagRecoSelected, tagRecosDisplayed } from '../../../analytics/mlEventAnalytics';
import {
  Container,
  Description,
  SimilarTicketsDescription,
  MacroWizard,
  SectionContainer,
  PreSelectionSection,
  SimilarTicketSection,
  Title,
  SubText,
  RecommendationTitle,
  RecommendationSubText,
} from './MWSelectOptions.styles';

export class MWSelectOptions extends Component {
  handleSelection(nextPath) {
    this.props.setMacroWizardPath(nextPath);
    this.props.restartDecisionFlowRequested({
      currentConversationId: this.props.conversationId,
      tagPath: nextPath,
    });
    trackMacroWizardCategorySelected(nextPath);
  }

  getHeaderSubtext() {
    const { tagPathArray } = this.props;
    switch (tagPathArray.length) {
      case 0:
        return <SubText>Please first select a category.</SubText>;
      case 1:
        return <SubText>Please now select a subcategory.</SubText>;
      default:
        return null;
    }
  }

  showRecommendations() {
    return (
      !this.props.tagPathArray.length &&
      !!this.props.recommendedMLTags.length &&
      this.props.shouldDisplayRecommendedMLTags &&
      !this.props.isReviewTicket
    );
  }

  render() {
    const { possibleNextPaths, tagPathArray, tagPath, macroListByPath, recommendedMLTags, simplrTaggingActive } =
      this.props;

    const macroList = macroListByPath[tagPath] || [];
    const sectionBlock = possibleNextPaths.map((nextPath) => {
      // split the path
      const splitNextPath = nextPath.split('--').map((item) => item.trim());
      const displayText = splitNextPath[this.props.currDepth];

      return (
        <SectionContainer key={nextPath}>
          <DecisionTreeButton onClick={() => this.handleSelection(nextPath)}>{displayText}</DecisionTreeButton>
        </SectionContainer>
      );
    });

    const recommendationBlock = recommendedMLTags.map((nextPath) => {
      return (
        <SectionContainer key={nextPath}>
          <DecisionTreeButton
            onClick={() => {
              tagRecoSelected(nextPath);
              this.handleSelection(nextPath);
            }}
          >
            {nextPath}
          </DecisionTreeButton>
        </SectionContainer>
      );
    });

    // we don't want extra padding around the buttons if we are at the root of the
    // tree or if there are macros to display
    const extraPaddingNotNeeded = !!macroList.length || !tagPathArray.length;

    if (this.showRecommendations()) {
      tagRecosDisplayed();
    }

    return (
      <Container>
        {!!possibleNextPaths.length && (
          <PreSelectionSection showUnderline={macroList.length && possibleNextPaths.length}>
            {tagPathArray.length < 2 ? (
              <Description noBottomSection={!this.showRecommendations()}>
                <Title>
                  {simplrTaggingActive ? 'You have not yet taken this ticket.' : 'Before you respond to this ticket'}
                  <br />
                  {simplrTaggingActive
                    ? "Before responding, let's find the right response."
                    : "let's find a matching macro."}
                </Title>
                {this.getHeaderSubtext()}
              </Description>
            ) : null}
            <MacroWizard
              recommendationsActive={this.showRecommendations()}
              showUnderline={!tagPathArray.length && recommendedMLTags.length}
            >
              {sectionBlock}
            </MacroWizard>
            {this.showRecommendations() && (
              <SimilarTicketSection>
                <SimilarTicketsDescription>
                  <RecommendationTitle>Similar tickets have been classified like this in the past.</RecommendationTitle>
                  <RecommendationSubText>
                    Choose one of these options if you think it properly categorizes this ticket.
                  </RecommendationSubText>
                </SimilarTicketsDescription>
                <MacroWizard extraPaddingNotNeeded={extraPaddingNotNeeded}>{recommendationBlock}</MacroWizard>
              </SimilarTicketSection>
            )}
          </PreSelectionSection>
        )}
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  businessId: extract.getSimplrAccountIdOfSelectedTicket(state),
  conversationId: extract.getselectedConversationId(state),
  message: extract.extractFirstMessage(state),
  possibleNextPaths: extract.getPossibleNextMacroWizardEdge(state),
  currDepth: extract.extractCurrentMacroWizardDepth(state),
  macroListByPath: extract.extractMacroListByPath(state),
  tagPathArray: extract.extractMacroWizardTagPathArray(state),
  tagPath: extract.extractCurrentMacroWizardPath(state),
  recommendedMLTags: extract.getRecommendedMLTagsForSelectedTicket(state),
  shouldDisplayRecommendedMLTags: extract.getToDisplayRecommendedMLTagsForSelectedTicket(state),
  multiIntentClassification: extract.getMultiIntentClassification(state),
  simplrTaggingActive: extract.getSimplrTaggingActive(state),
  isReviewTicket: extract.isSelectedTicketReviewTicket(state),
});

const mapStateToDispatch = (dispatch) => ({
  setMacroWizardPath: (path) => {
    dispatch(setMacroWizardPath(path));
  },
  setNoMatchPage: (value) => {
    dispatch(setNoMatchPage(value));
  },
  restartDecisionFlowRequested: (restartDecisionFlowData) => {
    dispatch(restartDecisionFlowRequested(restartDecisionFlowData));
  },
});

export default connect(mapStateToProps, mapStateToDispatch)(MWSelectOptions);
